import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import OperatorExtension, {
  CallDataType,
  FormDataType,
  PhoneCallType,
  RingingDataType,
  SelectedCustomerType,
  SelectedProductTypeType,
  SetCallDataPayloadType,
} from './types'

type CallDetailStateType = {
  isRinging: boolean
  selectedRoleFilter: string
  callData: CallDataType
  ringingData: RingingDataType
  formData: FormDataType
  showCallRegistration: boolean
}

const initialState: CallDetailStateType = {
  isRinging: false,
  selectedRoleFilter: 'all',
  ringingData: {
    phoneCallId: '',
    callerName: '',
    isNewCustomer: true,
    accountName: '',
    contactName: '',
    leadName: '',
    invoiceCount: 0,
    quoteCount: 0,
    phoneNumber: '',
    isVIP: false,
  },
  callData: {
    phoneCallId: '',
    isHangup: false,
    callerName: '',
    isNewCustomer: true,
    accountName: '',
    contactName: '',
    leadName: '',
    startDate: '',
    invoiceCount: 0,
    quoteCount: 0,
    phoneNumber: '',
    isVIP: false,
    lastExpertTalked: {},
    preName: {},
    phoneNumbers: [],
    opportunityId: null,
    leadSource: {
      value: 100000005,
      label: 'سایت شرکت',
    },
  },
  formData: {
    callType: PhoneCallType.LEAD,
    selectedProductTypes: [],
    newLeadName: '',
    leadSource: 100000005,
    description: '',
    selectedCustomer: undefined,
    selectedOperator: null,
    transferredBusinessUnit: '',
    topic: undefined,
    preLeadName: undefined,
    isOverload: false,
    isCooperationRequest: false,
  },
  showCallRegistration: false,
}

const callDetailSlice = createSlice({
  name: 'callDetail',
  initialState,
  reducers: {
    resetFormData(state) {
      state.formData = initialState.formData
    },
    resetCallData(state) {
      state.callData = initialState.callData
    },
    resetRingingData(state) {
      state.ringingData = initialState.ringingData
    },
    setCallData(state, { payload }: PayloadAction<SetCallDataPayloadType>) {
      state.callData = {
        isHangup: false,
        startDate: new Date().toISOString(),
        ...payload,
      }
    },
    setFormData(state, { payload }: PayloadAction<any>) {
      state.formData = {
        ...state.formData,
        ...payload,
      }
    },
    setRingingData(state, { payload }: PayloadAction<SetCallDataPayloadType>) {
      state.ringingData = payload
      state.isRinging = true
    },
    setTopic(state, { payload }: PayloadAction<string>) {
      state.formData.topic = payload
    },
    setLastExpertTalked(
      state,
      { payload }: PayloadAction<CallDataType['lastExpertTalked']>
    ) {
      state.callData.lastExpertTalked = payload
    },
    setHangup(state, { payload }) {
      state.callData.isHangup = payload || true
    },
    setPreLeadName(state, { payload }: PayloadAction<number>) {
      state.formData.preLeadName = payload
    },
    setLeadName(state, { payload }: PayloadAction<string>) {
      state.formData.leadName = payload
    },
    setIsRinging(state, { payload }: PayloadAction<boolean>) {
      state.isRinging = payload
    },
    setCallType(state, { payload }: PayloadAction<PhoneCallType>) {
      state.formData.callType = payload
    },
    selectOperator(
      state,
      { payload }: PayloadAction<OperatorExtension | null>
    ) {
      state.formData.selectedOperator = payload
    },
    setSelectedRoleFilter(state, { payload }: PayloadAction<string>) {
      state.selectedRoleFilter = payload
    },
    setShowCallRegistration(state, { payload }: PayloadAction<boolean>) {
      state.showCallRegistration = payload
    },
    setLeadSource(state, { payload }: PayloadAction<number>) {
      state.formData.leadSource = payload
    },
    setDescription(state, { payload }: PayloadAction<string>) {
      state.formData.description = payload
    },
    setNewLeadName(state, { payload }: PayloadAction<string>) {
      state.formData.newLeadName = payload
    },
    setSelectedCustomer(
      state,
      { payload }: PayloadAction<SelectedCustomerType | undefined>
    ) {
      state.formData.selectedCustomer = payload
    },
    setSelectedProductTypes(
      state,
      { payload }: PayloadAction<SelectedProductTypeType[]>
    ) {
      state.formData.selectedProductTypes = payload
    },
    setTransferredBusinessUnits(state, { payload }: PayloadAction<string>) {
      state.formData.transferredBusinessUnit = payload
    },
  },
})

export const {
  setPreLeadName,
  setTopic,
  setRingingData,
  setSelectedRoleFilter,
  setIsRinging,
  setCallData,
  setCallType,
  selectOperator,
  setShowCallRegistration,
  setLeadSource,
  setDescription,
  setNewLeadName,
  setSelectedCustomer,
  setSelectedProductTypes,
  setTransferredBusinessUnits,
  setHangup,
  resetFormData,
  resetRingingData,
  resetCallData,
  setLeadName,
  setFormData,
  setLastExpertTalked,
} = callDetailSlice.actions
export default callDetailSlice.reducer
